enum StatusType {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  INACTIVE = "INACTIVE",
  CANCELED = "CANCELED",
  CLOSED = "CLOSED",
  FROZEN = "FROZEN",
  ISSUED = "ISSUED",
}

export default StatusType;
